import { TenantChildNode } from '@fluentsms/graphql';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DrawerAutocomplete, DrawerOptions, renderInput } from './base';
import { useCompanyAutocomplete } from './hooks';

type CompanyAutocompleteProps = {
  label: string;
  companies: TenantChildNode[];
  disabled?: boolean;
};

export const CompanyAutocomplete = ({ label, companies, disabled }: CompanyAutocompleteProps): JSX.Element => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const fieldName = 'l2Id';
  const selectedId = watch(fieldName);
  const { options, selectedOption } = useCompanyAutocomplete(companies, selectedId);

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { ref, onChange, value, ...props } }) => (
        <DrawerAutocomplete
          {...props}
          disableClearable={true}
          value={selectedOption as DrawerOptions}
          renderInput={renderInput({ label: 'Company', ref, error: !!errors[fieldName], isRequired: true })}
          onChange={(_: React.ChangeEvent<unknown>, option: DrawerOptions | null) => {
            onChange(option?.itemId || '');
          }}
          label={label}
          options={options}
          disabled={disabled}
        />
      )}
    />
  );
};
